
import React from "react";
import {getBrand, authenticate, findCenter} from "../lib/functions";
import FadeIn from "./Fadein.js";
import Footer from "./Footer";

export default class Login extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
        brand : null,
        loginCenterId : '',
        step : 0,
        loginError : '',
        schoolname : null,
        loginUsername : '',
        loginPassword : ''
    }
  }
    
    componentDidMount = () =>  {
        this.setState({brand : getBrand(), step : 1});
    }

    updateValue = (e) => { 
        this.setState({[e.target.id] : e.target.value});
        this.setState({loginError : ''});
    }

    loginFindCenter = () => {
        if(this.state.loginCenterId) {
            this.setState({loginError : ''});
            findCenter(this.state.loginCenterId, (data) => {
                
                if(data.error === 1) {
                    this.setState({loginError : data.txt});
                }
                if(data.error === 0) {
                    this.setState({
                        schoolname : data.schoolname,
                        step : 2
                    });
                }
            });
        }
        else {
            this.setState({loginError : 'Please enter a valid centre ID.'});
        }
    }

    login = () => {
        if(this.state.loginUsername && this.state.loginPassword) {
            this.setState({loginError : ''});
            authenticate(this.state.loginUsername, this.state.loginPassword, (data) => {

                if(data.error === 0) {
                    this.props.loggedIn(data);
                }
                else {
                    this.setState({loginError : data.txt});
                }
            })
        }
        else {

            this.setState({loginError : 'User name and password are required.'});
        }
    }

    handleKeyPress = (event) => {
        if(event.key === 'Enter'){
            if(this.state.step == 1) { 
                this.loginFindCenter();
            }
            if(this.state.step == 2) { 
                this.login();
            } else { 
        }
      }
    }  

  render() {
  
            return (      
            <div className="login-background" onKeyPress={this.handleKeyPress}>
              
               { this.state.step == 1 ?
                <FadeIn>
                    <div tabIndex="-1" role="dialog">
                        <div className="modal-dialog" role="document">
                            <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title">Please log in</h5>
                            </div>
                            <div className="modal-body">
                                <div className="form-group row">
                                    <label className="col-sm-3" htmlFor="schoolSearch">Centre ID</label>
                                    <div className="col-sm-9">
                                        <input type="text" autoFocus  autoComplete="new-password" className="form-control" name="" id="loginCenterId"  value={this.state.loginCenterId} onChange={this.updateValue}/>
                                    </div>
                                </div>
                            </div>
                            <div className="modal-footer d-flex justify-content-between">
                                <div className="login-error-message">{this.state.loginError}</div>
                                    <button type="button" className="btn btn-primary" onClick={this.loginFindCenter}>Next</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </FadeIn>
                : null }
            
            { this.state.step == 2 ?
                <FadeIn>
                    <div tabIndex="-1" role="dialog">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">{this.state.schoolname}</h5>
                        </div>
                        <div className="modal-body">
                            <div className="form-group row">
                                <label className="col-sm-3" htmlFor="schoolSearch">User name</label>
                                <div className="col-sm-9">
                                    <input type="text" autoComplete="new-password" className="form-control" name="" id="loginUsername" autoFocus value={this.state.loginUsername} onChange={this.updateValue}/>
                                </div>
                            </div>
                            <div className="form-group row">
                                <label className="col-sm-3" htmlFor="schoolSearch">Password</label>
                                <div className="col-sm-9">
                                    <input type="password" autoComplete="new-password" className="form-control" name="" id="loginPassword" value={this.state.loginPassword} onChange={this.updateValue}/>
                                </div>
                            </div>
                        </div>
                        <div className="modal-footer d-flex justify-content-between">
                            <div className="login-error-message">{this.state.loginError}</div>
                            <button type="button" className="btn btn-primary" id="loginAuthenticate" onClick={this.login}>Login</button>
                        </div>
                        </div>
                    </div>
                    <p className="quick-guide-text">For guidance please see the <a href="https://stsupport.exampro.co.uk/kb/ " target="_blank" rel="noreferrer">Student Portal Quick Guide</a></p>
                    </div>
                </FadeIn>
            : null 
            }
            <Footer />
            </div>
            
         )
   }
}

